import { render, staticRenderFns } from "./WagonBrake.vue?vue&type=template&id=61c0a924&scoped=true"
import script from "./WagonBrake.vue?vue&type=script&lang=js"
export * from "./WagonBrake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c0a924",
  null
  
)

export default component.exports